<template>
  <div class="container">
    <div class="columns">
      <div class="column is-flex
                         is-justify-content-space-between
                         is-align-items-center
                         is-flex-wrap-wrap">
        <o-field variant="primary">
          <o-input placeholder="Domain" type="search" v-model="searchQuery"></o-input>
          <o-button variant="primary" @click="search">Search</o-button>
        </o-field>
        <o-field v-if="domain" variant="info">
          <o-button
            @click="$router.push({name: 'CustomFields', query: {q: domain.id}})"
            class="is-info">
            <o-icon icon="folder-plus"/>
            <span> Custom Fields</span>
          </o-button>
        </o-field>
      </div>
      <div class="column" v-if="domain">
        <h1 class="title mb-2">{{ domain.name }}
          <span v-if="isMyDomain" class="badge">Your</span>
          <span v-else class="badge badge-info">Client</span>
        </h1>
        <h4><b>ID:</b> {{ domain.id }}</h4>
        <a :href="domain.admin_link" target="_blank">Details</a>
        <!--        <o-button-->
        <!--          size="small"-->
        <!--          @click="loginAs()"-->
        <!--          class="my-2 is-success">-->
        <!--          Login As-->
        <!--        </o-button>-->
      </div>
    </div>
    <div v-if="domain" class="columns">
      <div class="column">
        <div class="is-flex is-justify-content-space-between is-align-items-center">
          <h1 class="title is-4">Departments</h1>
          <o-button v-if="isMyDomain" class="my-4" variant="primary" @click="addDepartment">Add department</o-button>
          <!--          <o-button v-if="isMyDomain && departments.length > 0"-->
          <!--                    variant="danger"-->
          <!--                    @click="deleteAllDepartments">Delete All-->
          <!--          </o-button>-->
        </div>
        <o-table :data="departments ? departments : []"
                 :draggable="isMyDomain"
                 @dragstart="startDragDepartment($event)"
                 @dragend="endDragDepartment($event)"
                 @drop="onDropTemplate($event)"
                 @dragover="(payload) => payload.event.preventDefault()"
                 @dragenter="(payload) => payload.event.preventDefault()">

          <o-table-column field="name" label="Department" v-slot="props">
            {{ props.row.name }}
          </o-table-column>
          <o-table-column field="id" label="ID" numeric v-slot="props">
            {{ props.row.id }}
          </o-table-column>
          <o-table-column field="template" label="Template" v-slot="props">
            <o-field class="m-0">
              <o-select placeholder="Select"
                        :disabled="!isMyDomain"
                        v-model="props.row.template"
                        @change="changeDepartmentTemplate(props.row.id, props.row.template)">
                <optgroup label="Custom Templates">
                  <option v-for="customTemplate in customTemplates"
                          :value="customTemplate.id">
                    {{ customTemplate.name_with_id }}
                  </option>
                </optgroup>
                <optgroup label="Default Templates">
                  <option v-for="defaultTemplate in defaultTemplates"
                          :value="defaultTemplate.id">
                    {{ defaultTemplate.name_with_id }}
                  </option>
                </optgroup>
              </o-select>
            </o-field>

          </o-table-column>
          <o-table-column v-slot="props">
            <o-tooltip label="Show Template" position="top" variant="info">
              <o-icon
                clickable
                native-type="button"
                icon="eye"
                @click="showTemplate(props.row.template)"/>
            </o-tooltip>
          </o-table-column>
          <o-table-column v-slot="props" v-if="isMyDomain">
            <o-tooltip label="Edit" position="top" variant="info">
              <o-icon
                clickable
                native-type="button"
                icon="pen"
                @click="departmentEdit(props.row)"/>
            </o-tooltip>
          </o-table-column>
          <o-table-column v-slot="props" v-if="isMyDomain">
            <o-tooltip label="Duplicate" position="top" variant="info">
              <o-icon
                clickable
                native-type="button"
                variant="info"
                icon="clone"
                @click="duplicateDepartment(props.row)"/>
            </o-tooltip>
          </o-table-column>
          <o-table-column v-slot="props" v-if="!isMyDomain">
            <o-tooltip label="Export to your domain" position="top" variant="info">
              <o-icon
                clickable
                native-type="button"
                icon="file-export"
                variant="success"
                @click="exportDepartment(props.row)"/>
            </o-tooltip>
          </o-table-column>
          <o-table-column v-slot="props" v-if="isMyDomain">
            <o-tooltip label="Delete" position="top" variant="danger">
              <o-icon clickable
                      icon="trash"
                      variant="danger"
                      @click="deleteDepartment(props.row)"/>
            </o-tooltip>
          </o-table-column>
        </o-table>
      </div>
      <div class="column">
        <div class="is-flex is-justify-content-space-between is-align-items-center">
          <h1 class="title is-4">Domain Templates</h1>
          <o-button v-if="isMyDomain" class="my-4" variant="primary" @click="addTemplate">Add template</o-button>
          <!--          <o-button v-if="isMyDomain && customTemplates.length > 0"-->
          <!--                    variant="danger"-->
          <!--                    @click="deleteAllTemplates">Delete All-->
          <!--          </o-button>-->
        </div>
        <o-table :data="customTemplates ? customTemplates : []"
                 :selected.sync="selectedTemplate"
                 :row-class="(row) => departments.map((el) => el.template).includes(row.id) ? 'bound-template' : ''"
                 :draggable="isMyDomain"
                 @dragstart="startDragTemplate($event)"
                 @dragend="endDragTemplate($event)"
                 @drop="onDropDepartment($event)"
                 @dragover="(payload) => payload.event.preventDefault()"
                 @dragenter="(payload) => payload.event.preventDefault()">
          <o-table-column field="id" label="ID" numeric v-slot="props">
            {{ props.row.id }}
          </o-table-column>
          <o-table-column field="date_created" label="Date created" numeric v-slot="props">
            {{ new Date(props.row.date_created).toLocaleDateString() }}
          </o-table-column>
          <o-table-column v-slot="props" v-if="isMyDomain">
            <o-tooltip v-if="!props.row.read_only" label="Edit" position="top" variant="info">
              <o-icon
                clickable
                native-type="button"
                icon="pen"
                @click="$router.push({name: 'TemplateEditor', params: {id: props.row.id}})"/>
            </o-tooltip>
          </o-table-column>
          <o-table-column v-slot="props" v-if="isMyDomain">
            <o-tooltip label="Duplicate" position="top" variant="info">
              <o-icon
                clickable
                native-type="button"
                icon="clone"
                variant="info"
                @click="duplicateTemplate(props.row.id)"/>
            </o-tooltip>
          </o-table-column>
          <o-table-column v-slot="props" v-if="!isMyDomain">
            <o-tooltip label="Export to your domain" position="top" variant="info">
              <o-icon
                clickable
                native-type="button"
                icon="file-export"
                variant="success"
                @click="exportTemplate(props.row.id)"/>
            </o-tooltip>
          </o-table-column>
          <o-table-column v-slot="props" v-if="isMyDomain">
            <o-tooltip v-if="!props.row.read_only"
                       label="Delete" position="top" variant="danger">
              <o-icon clickable
                      icon="trash"
                      variant="danger"
                      @click="deleteTemplate(props.row.id)"/>
            </o-tooltip>
          </o-table-column>
        </o-table>

        <h1 v-if="isMyDomain" class="title my-4 is-4">Default Templates</h1>
        <o-table v-if="isMyDomain"
                 :data="defaultTemplates ? defaultTemplates : []"
                 :selected.sync="selectedTemplate"
                 :row-class="(row) => departments.map((el) => el.template).includes(row.id) ? 'bound-template' : ''"
                 :draggable="isMyDomain"
                 @dragstart="startDragTemplate($event)"
                 @dragend="endDragTemplate($event)"
                 @drop="onDropDepartment($event)"
                 @dragover="(payload) => payload.event.preventDefault()"
                 @dragenter="(payload) => payload.event.preventDefault()">
          <o-table-column field="id" label="ID" numeric v-slot="props">
            {{ props.row.id }}
          </o-table-column>
          <o-table-column field="display_name" label="Name" v-slot="props">
            {{ props.row.display_name }}
          </o-table-column>
          <o-table-column field="date_created" label="Date created" numeric v-slot="props">
            {{ new Date(props.row.date_created).toLocaleDateString() }}
          </o-table-column>
          <o-table-column v-slot="props">
            <o-tooltip label="Duplicate" position="top" variant="info">
              <o-icon
                clickable
                native-type="button"
                icon="clone"
                variant="info"
                @click="duplicateTemplate(props.row.id)"/>
            </o-tooltip>
          </o-table-column>
        </o-table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import {mapGetters} from "vuex";

import DepartmentModal from "../components/modals/DepartmentModal.vue"
import Confirm from "../components/modals/Confirm";

export default {
  name: "Domain",

  data() {
    return {
      searchQuery: null,
      domain: null,
      departments: null,
      defaultTemplates: null,
      customTemplates: null,
      selectedTemplate: null,
      draggingTemplate: null,
      draggingDepartment: null,
    }
  },
  methods: {
    startDragTemplate(payload) {
      this.draggingTemplate = payload.row
    },
    endDragTemplate(payload) {
      this.draggingTemplate = null
    },
    onDropTemplate(payload) {
      if (this.draggingTemplate)
        this.changeDepartmentTemplate(payload.row.id, this.draggingTemplate.id)
    },
    startDragDepartment(payload) {
      this.draggingDepartment = payload.row
    },
    endDragDepartment(payload) {
      this.draggingDepartment = null
    },
    onDropDepartment(payload) {
      if (this.draggingDepartment)
        this.changeDepartmentTemplate(this.draggingDepartment.id, payload.row.id)
    },
    search() {
      if (this.$route.query.q !== this.searchQuery)
        this.$router.replace({'name': 'Domain', query: {q: this.searchQuery}})
      else
        this.getDomain()
    },
    getDomain() {
      if (this.searchQuery)
        axios.get('/api/domain/', {params: {'q': this.searchQuery.trim()}})
          .then(response => {
            this.domain = response.data.domain
            this.departments = response.data.departments
            this.defaultTemplates = response.data.default_templates
            this.customTemplates = response.data.custom_templates
          })
          .catch(error => {
            this.domain = null
            this.$oruga.notification.open({
              message: error.response.data.message ? error.response.data.message : 'Something went wrong!',
              rootClass: 'toast-notification-danger',
              position: 'top',
              duration: 3000
            })
            console.error(error);
          })
      else
        this.domain = null
    },
    addTemplate() {
      axios.post('/api/template/', {'domain_id': this.domain.id})
        .then(response => {
          this.getDomain()
          console.log(response.data)
          this.$oruga.notification.open({
            message: 'Template #' + response.data.id + ' was added',
            rootClass: 'toast-notification-success',
            position: 'top',
            duration: 3000
          })
          console.log(response.data)
        })
        .catch(error => {
          this.$oruga.notification.open({
            message: 'Something went wrong!',
            rootClass: 'toast-notification-danger',
            position: 'top',
            duration: 3000
          })
          console.error(error);
        })
    },
    duplicateTemplate(templateID) {
      axios.post('/api/template/duplicate/' + templateID, {'domain_id': this.domain.id})
        .then(response => {
          this.getDomain()
          this.$oruga.notification.open({
            message: `Template #${templateID} was duplicated`,
            rootClass: 'toast-notification-success',
            position: 'top',
            duration: 3000
          })
          console.log(response.data)
        })
        .catch(error => {
          this.$oruga.notification.open({
            message: 'Something went wrong!',
            rootClass: 'toast-notification-danger',
            position: 'top',
            duration: 3000
          })
          console.error(error);
        })
    },
    exportTemplate(templateID) {
      axios.post('/api/template/export/' + templateID)
        .then(response => {
          this.$oruga.notification.open({
            message: `Template #${templateID} exported to ${this.getAdmin.domain}`,
            rootClass: 'toast-notification-success',
            position: 'top',
            duration: 3000
          })
          console.log(response.data)
        })
        .catch(error => {
          this.$oruga.notification.open({
            message: 'Something went wrong!',
            rootClass: 'toast-notification-danger',
            position: 'top',
            duration: 3000
          })
          console.error(error);
        })
    },
    deleteTemplate(templateID) {
      this.$oruga.modal.open({
        parent: this,
        component: Confirm,
        custom: true,
        trapFocus: true,
        props: {
          'title': `Deleting template #${templateID}`,
          'message': `Are you sure you want to delete <b>#${templateID}</b>?`,
          'confirmText': "Delete",
          'variant': 'danger'
        },
        events: {
          'onConfirm': () => {
            axios.delete('/api/template/' + templateID)
              .then(() => {
                this.$oruga.notification.open({
                  message: `Template #${templateID} was deleted`,
                  rootClass: 'toast-notification-success',
                  position: 'top',
                  duration: 3000
                })
                this.getDomain()
              })
              .catch(error => {
                this.$oruga.notification.open({
                  message: 'Something went wrong!',
                  rootClass: 'toast-notification-danger',
                  position: 'top',
                  duration: 3000
                })
                console.error(error);
              })
          }
        }
      })
    },
    deleteAllTemplates() {
      this.$oruga.modal.open({
        parent: this,
        component: Confirm,
        custom: true,
        trapFocus: true,
        props: {
          'title': `Deleting ALL templates`,
          'message': `Are you sure you want to delete <b>ALL</b> templates?`,
          'confirmText': "Delete",
          'variant': 'danger'
        },
        events: {
          'onConfirm': () => {
            axios.post('/api/domain/templates/delete', {'domain_id': this.domain.id})
              .then(() => {
                this.$oruga.notification.open({
                  message: 'Deleted',
                  rootClass: 'toast-notification-success',
                  position: 'top',
                  duration: 3000
                })
                this.getDomain()
              })
              .catch(error => {
                this.$oruga.notification.open({
                  message: 'Something went wrong!',
                  rootClass: 'toast-notification-danger',
                  position: 'top',
                  duration: 3000
                })
                console.error(error);
              })
          }
        }
      })
    },
    addDepartment() {
      this.$oruga.modal.open({
        parent: this,
        component: DepartmentModal,
        custom: true,
        trapFocus: true,
        props: {'title': "New department"},
        events: {
          'onComplete': (name) => {
            axios.post('/api/department/', {'name': name, 'domain_id': this.domain.id})
              .then(response => {
                this.getDomain()
                this.$oruga.notification.open({
                  message: `Department ${name} was added`,
                  rootClass: 'toast-notification-success',
                  position: 'top',
                  duration: 3000
                })
                console.log(response.data)
              })
              .catch(error => {
                this.$oruga.notification.open({
                  message: 'Something went wrong!',
                  rootClass: 'toast-notification-danger',
                  position: 'top',
                  duration: 3000
                })
                console.error(error);
              })
          }
        }
      })
    },
    duplicateDepartment(dept) {
      axios.post('/api/department/duplicate/' + dept.id)
        .then(response => {
          this.getDomain()
          this.$oruga.notification.open({
            message: `Department ${dept.name} was duplicated`,
            rootClass: 'toast-notification-success',
            position: 'top',
            duration: 3000
          })
          console.log(response.data)
        })
        .catch(error => {
          this.$oruga.notification.open({
            message: 'Something went wrong!',
            rootClass: 'toast-notification-danger',
            position: 'top',
            duration: 3000
          })
          console.error(error);
        })
    },
    exportDepartment(dept) {
      axios.post('/api/department/export/' + dept.id)
        .then(response => {
          this.$oruga.notification.open({
            message: `Department ${dept.name} exported to ${this.getAdmin.domain}`,
            rootClass: 'toast-notification-success',
            position: 'top',
            duration: 3000
          })
        })
        .catch(error => {
          this.$oruga.notification.open({
            message: 'Something went wrong!',
            rootClass: 'toast-notification-danger',
            position: 'top',
            duration: 3000
          })
          console.error(error);
        })
    },
    changeDepartmentTemplate(department_id, template_id) {
      axios.put('/api/department/' + department_id, {'template': template_id})
        .then(() => {
          this.$oruga.notification.open({
            message: 'Template assigned',
            rootClass: 'toast-notification-success',
            position: 'top',
            duration: 3000
          })
          this.getDomain()
        })
        .catch(error => {
          this.$oruga.notification.open({
            message: 'Something went wrong!',
            rootClass: 'toast-notification-danger',
            position: 'top',
            duration: 3000
          })
          console.error(error);
        })
    },
    departmentEdit(dept) {
      this.$oruga.modal.open({
        parent: this,
        component: DepartmentModal,
        custom: true,
        trapFocus: true,
        props: {'title': `Edit department #${dept.id}`, 'initialData': dept},
        events: {
          'onComplete': (name) => {
            axios.put('/api/department/' + dept.id, {'name': name})
              .then(response => {
                this.$oruga.notification.open({
                  message: 'Department name changed',
                  rootClass: 'toast-notification-success',
                  position: 'top',
                  duration: 3000
                })
                this.getDomain()
              })
              .catch(error => {
                this.$oruga.notification.open({
                  message: 'Something went wrong!',
                  rootClass: 'toast-notification-danger',
                  position: 'top',
                  duration: 3000
                })
                console.error(error);
              })
          }
        }
      })
    },
    deleteDepartment(dept) {
      this.$oruga.modal.open({
        parent: this,
        component: Confirm,
        custom: true,
        trapFocus: true,
        props: {
          'title': `Deleting ${dept.name}`,
          'message': `Are you sure you want to delete <b>${dept.name}</b>?`,
          'confirmText': "Delete",
          'variant': 'danger'
        },
        events: {
          'onConfirm': () => {
            axios.delete('/api/department/' + dept.id)
              .then(() => {
                this.$oruga.notification.open({
                  message: `Department ${dept.name} was deleted`,
                  rootClass: 'toast-notification-success',
                  position: 'top',
                  duration: 3000
                })
                this.getDomain()
              })
              .catch(error => {
                this.$oruga.notification.open({
                  message: 'Something went wrong!',
                  rootClass: 'toast-notification-danger',
                  position: 'top',
                  duration: 3000
                })
                console.error(error);
              })
          }
        }
      })
    },
    deleteAllDepartments() {
      this.$oruga.modal.open({
        parent: this,
        component: Confirm,
        custom: true,
        trapFocus: true,
        props: {
          'title': `Deleting ALL departments`,
          'message': `Are you sure you want to delete <b>ALL</b> departments?`,
          'confirmText': "Delete",
          'variant': 'danger'
        },
        events: {
          'onConfirm': () => {
            axios.post('/api/domain/departments/delete', {'domain_id': this.domain.id})
              .then(() => {
                this.$oruga.notification.open({
                  message: 'Deleted',
                  rootClass: 'toast-notification-success',
                  position: 'top',
                  duration: 3000
                })
                this.getDomain()
              })
              .catch(error => {
                this.$oruga.notification.open({
                  message: 'Something went wrong!',
                  rootClass: 'toast-notification-danger',
                  position: 'top',
                  duration: 3000
                })
                console.error(error);
              })
          }
        }
      })
    },
    showTemplate(templateID) {
      this.selectedTemplate = [...this.customTemplates, ...this.defaultTemplates].find(x => x.id === templateID)
    },
    loginAs() {
      axios.post('/api/login_as/', {'customer_email': this.domain.admin})
        .then((response) => {
          window.open(response.data['host'], '_blank');
        })
        .catch(error => {
          console.error(error);
        })
    },
  },
  watch: {
    $route(to, from) {
      if (this.$route.path === to.path) {
        this.searchQuery = to.query.q
        this.getDomain()
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['getAdmin']),
    isMyDomain() {
      return this.domain.id === this.getAdmin.domain_id
    }
  },
  created() {
    this.searchQuery = this.$route.query.q
    this.getDomain()
  }
}
</script>

<style scoped>
.o-field {
  flex-grow: 0 !important;
}

.badge {
  display: inline-block;
  padding: .35em .65em;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: top;
  border-radius: 0.25rem;
  background-color: #00d1b2;
  border-color: transparent;
  color: #fff;
}

.badge-info {
  background-color: #3e8ed0;
}

</style>
